<div
    class="ticket-card-wrapper mt-4 overflow-hidden rounded-lg border-2 border-solid dark:border-contrast-yellow"
    #ticketCardWrapper
    [ngClass]="{
        'pn-app-light:border-primary border-secondary': isTicketDisplayedAsActive && !isRecent,
        'ticket-card-highlighted': isActionsModalOpen
    }">
    <section
        class="flex border-opacity-10 dark:border dark:border-solid dark:border-contrast-yellow dark:bg-contrast-black"
        [ngClass]="{
            'sr-app-light:border-secondary orb-app-light:border-secondary gl-light:border-orange_dark var-app-light:border-secondary border-opacity-100':
                isTicketDisplayedAsActive,
            'rounded-md': !ticket.loaned,
            'bg-grey-white_smoke': (!isTicketDisplayedAsActive && !ticket.loaned) || isRecent,
            'bg-primary-light': isTicketDisplayedAsActive && !isRecent,
            'bg-green': isTicketDisplayedAsActive && env.IS_NEW_AFC && !isRecent,
            'bg-grey-silver': !isTicketDisplayedAsActive && env.IS_NEW_AFC && ticket.loaned && !isRecent,
            'bg-red-secondary': env.IS_NEW_AFC && isTicketCanceled && !isRecent,

            'shadow-cardStack': isMultiTrip,

            'shadowActiveBooklet': isMultiTrip && isTicketDisplayedAsActive,
            'shadowCancelledBooklet': isMultiTrip && isTicketCanceled,
            'shadowInactiveBooklet': isMultiTrip && ((!isTicketDisplayedAsActive && !isTicketCanceled) || isRecent),

            'border-black': !isTicketDisplayedAsActive,
            'border-gray-600': ticket.loaned,
            'min-h-[104px]': env.TICKET_CARD_HIDE_PRICE,
            'min-h-[60px] !border': isRecent
        }">
        <div
            class="flex items-center pl-4"
            *ngIf="env.TICKET_LIST_V2_ENABLED && env.TICKET?.SHOW_PRODUCT_ICON !== false"
            [ngClass]="
                !isTicketCanceled &&
                !isTicketRefunded &&
                ticket.status !== 'EXPIRED' &&
                isTicketDisplayedAsActive &&
                env.IS_NEW_AFC
                    ? 'orb-app-light:text-secondary text-primary'
                    : 'text-grey-zambezy'
            ">
            <ion-icon
                class="var-app-light:text-primary min-h-[2.25rem] min-w-[2.25rem] dark:text-contrast-yellow"
                [ngClass]="{
                    'logo-color-active': isTicketDisplayedAsActive && env.IS_NEW_AFC,
                    'logo-color-inactive': !isTicketDisplayedAsActive && env.IS_NEW_AFC,
                    'logo-color-cancelled': isTicketCanceled && env.IS_NEW_AFC,
                    'logo-color-recent var-app-light:text-secondary orb-app-light:text-secondary': isRecent
                }"
                src="{{ assetsPath$ | async }}/img/ticket-details/icon-product-{{ ticket?.typeOfProduct?.code }}.svg">
            </ion-icon>
        </div>

        <button
            class="ticket-content flex grow items-center justify-between gap-2 border-r border-solid border-black border-opacity-10 px-5 text-left text-black hover:no-underline dark:border-contrast-yellow dark:text-contrast-yellow"
            [ngClass]="{
                '!border-0 !px-3': isRecent
            }"
            (click)="goToTicket(isRecent, ticket)"
            type="button">
            <div class="w-full py-1">
                <div
                    class="grid"
                    [ngClass]="{
                        'font-bold': isRecent,
                        'grid-cols-[1fr_auto]': env.TICKET_CARD_HIDE_PRICE,
                        'grid-cols-2': !env.TICKET_CARD_HIDE_PRICE
                    }">
                    <div class="flex w-full flex-col">
                        <div class="pb-2">
                            <div
                                class="grid"
                                [class]="env.TICKET_CARD_HIDE_PRICE ? 'pb-1' : 'pb-2'"
                                [ngClass]="{ '!pb-0 pt-2': isRecent }">
                                <div
                                    class="flex items-center justify-start gap-2 text-xs"
                                    [ngClass]="{
                                        'sr-app-light:text-secondary pn-light:text-primary pn-app-light:text-primary gl-light:opacity-100 var-app-light:text-grey-dark var-app-light:opacity-100 orb-app-light:text-grey-dark font-semibold dark:text-contrast-yellow':
                                            isTicketDisplayedAsActive,
                                        'text-xxs': isRecent
                                    }">
                                    <ng-container
                                        *ngIf="(!env.SHOW_TICKET_HISTORY_STATUS || !isHistoryTicket) && !isRecent">
                                        <ng-container *ngIf="env.IS_NEW_AFC; else oldTicketTitle">
                                            <div class="flex min-w-0 flex-1 items-center justify-between gap-2">
                                                <span
                                                    class="ticket-card-title min-w-0 flex-1 opacity-60 dark:opacity-100">
                                                    {{
                                                        (ticket.shortNames?.translations
                                                            | translateObjectField
                                                                : 'translations'
                                                                : translate.currentLang) ||
                                                            (ticket.typeOfProduct?.name
                                                                | translateObjectField
                                                                    : 'translations'
                                                                    : translate.currentLang)
                                                    }}
                                                </span>
                                                <div
                                                    class="flex shrink-0 items-center"
                                                    *ngIf="
                                                        (isMultiTrip && env.TICKET_LIST_SHOW_ACTIVATIONS_LEFT) ||
                                                        isTicketNotCurrentlyValid
                                                    ">
                                                    <span
                                                        class="var-app-light:text-black var-app-light:bg-secondary orb-app-light:text-secondary orb-app-light:text-white whitespace-nowrap rounded-full px-3 py-1 text-xxs font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                                                        *ngIf="isMultiTrip && env.TICKET_LIST_SHOW_ACTIVATIONS_LEFT">
                                                        {{ ticket.activationsLeft }} {{ 'TICKETS_LEFT' | translate }}
                                                    </span>
                                                    <span
                                                        class="whitespace-nowrap rounded-full bg-grey-zambezy px-3 py-1 text-xxs font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                                                        *ngIf="isTicketNotCurrentlyValid">
                                                        {{ 'TICKET_NOT_CURRENTLY_VALID' | translate }}
                                                    </span>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <ng-template #oldTicketTitle>
                                            <span class="opacity-60 dark:opacity-100">
                                                {{
                                                    (isTicketDisplayedAsActive && !isRecent
                                                        ? 'ACTIVE_TICKET'
                                                        : 'TICKET'
                                                    ) | translate
                                                }}
                                            </span>
                                        </ng-template>
                                    </ng-container>

                                    <ng-container *ngIf="isRecent && ticket.typeOfProduct?.name">
                                        {{ ticket.typeOfProduct?.name?.translations[translate.currentLang] }}
                                    </ng-container>

                                    <span
                                        *ngIf="isHistoryTicket && env.SHOW_TICKET_HISTORY_STATUS"
                                        [ngClass]="{ 'text-danger': env.HISTORY_TICKET_SHOW_STATUS }">
                                        {{ historyTicketStatus | translate }}
                                    </span>

                                    <div
                                        class="flex justify-start rounded-full border-2 border-solid border-black border-opacity-10 bg-white px-2 dark:border-contrast-yellow"
                                        *ngIf="
                                            (ticket.cardType === 'Q' || ticket.cardType === 'S') &&
                                            !env.TICKET_CARD_HIDE_QR_CHIP
                                        ">
                                        <div class="text-xs opacity-90 dark:text-contrast-yellow dark:opacity-100">
                                            {{ 'QR_CHIP' | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ng-container *ngIf="env.IS_NEW_AFC; else originalText">
                                <div *ngIf="ticket.geography?.zones?.[0]">
                                    <p class="flex justify-start font-bold text-black dark:text-contrast-yellow">
                                        {{
                                            ticket.geography.zones?.[0]?.name
                                                | translateObjectField: 'translations' : translate.currentLang
                                        }}
                                        <ng-container *ngIf="ticket.geography.zones.length > 1">
                                            <span class="icon icon-arrow-right align-middle text-xs"></span>
                                            {{
                                                ticket.geography.zones[ticket.geography.zones.length - 1]?.name
                                                    | translateObjectField: 'translations' : translate.currentLang
                                            }}
                                        </ng-container>
                                    </p>
                                </div>
                            </ng-container>

                            <ng-template #originalText>
                                <div
                                    class="flex items-center justify-start"
                                    [ngClass]="isRecent ? 'text-sm' : 'text-base'">
                                    {{ getProductTranslationOrDefault() | async }}
                                </div>
                            </ng-template>

                            <div *ngIf="ticket.userProfiles?.[0] && env.IS_NEW_AFC">
                                <span class="text-bas font-bold">
                                    {{
                                        ticket.userProfiles?.[0]?.nameTranslations
                                            | translateObjectField: 'translations' : translate.currentLang
                                    }}
                                </span>
                            </div>

                            <p class="w-full text-sm font-bold" *ngIf="isSingleTicketGroup">
                                {{ travellers }}
                            </p>
                        </div>
                    </div>

                    <div
                        class="flex items-center justify-end gap-2"
                        *ngIf="showTicketCardPrice || showTicketProgressSpinner">
                        <div class="relative" *ngIf="showTicketProgressSpinner && (ticketTimer$ | async) as timer">
                            <div class="relative h-11 w-11">
                                <mat-progress-spinner
                                    class="background-spinner absolute left-0 top-0 z-10"
                                    [value]="100"
                                    mode="determinate"
                                    diameter="44"
                                    strokeWidth="3">
                                </mat-progress-spinner>

                                <mat-progress-spinner
                                    class="ticket-timer-spinner absolute left-0 top-0 z-20"
                                    [value]="timer.progressValue"
                                    [attr.aria-label]="
                                        ('TICKET_VALIDITY_REMAINING' | translate) + ': ' + timer.remainingTimeText
                                    "
                                    [attr.aria-valuenow]="timer.progressValue"
                                    [attr.aria-valuemin]="0"
                                    [attr.aria-valuemax]="100"
                                    [attr.aria-valuetext]="timer.remainingTimeText + ' ' + ('REMAINING' | translate)"
                                    mode="determinate"
                                    diameter="44"
                                    strokeWidth="3"
                                    color="primary"
                                    role="progressbar">
                                </mat-progress-spinner>

                                <div
                                    class="absolute inset-0 flex h-11 w-11 items-center justify-center whitespace-pre-line text-center text-xs font-semibold leading-tight"
                                    [attr.aria-hidden]="true">
                                    {{ timer.remainingTimeText }}
                                </div>
                            </div>
                        </div>
                        <div
                            class="whitespace-nowrap text-xl font-bold text-black dark:text-contrast-yellow"
                            *ngIf="showTicketCardPrice">
                            <ng-container *ngIf="ticketPriceForDisplay !== null">
                                {{ ticketPriceForDisplay | moneyFormat }}
                            </ng-container>

                            <ng-container *ngIf="env.TICKET_LIST_V2_ENABLED && ticketPriceCurrency; else fareCurrency">
                                {{ ticketPriceCurrency | translate }}
                            </ng-container>

                            <ng-template #fareCurrency>
                                <ng-container *ngIf="ticketFarePriceCurrency; else defaultCurrency">
                                    {{ ticketFarePriceCurrency | translate }}
                                </ng-container>
                            </ng-template>

                            <ng-template #defaultCurrency>
                                <ng-container>
                                    {{ currency | translate }}
                                </ng-container>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <div class="w-full" *ngIf="!isRecent && ticket.cardType !== cardType.GLOBAL">
                    <ng-container *ngTemplateOutlet="ticketValidityBlock"></ng-container>
                </div>

                <div class="pb-2" *ngIf="showTicketProgressBar && (ticketTimer$ | async) as timer">
                    <div
                        class="mb-1 text-xs font-semibold text-black dark:text-contrast-yellow"
                        *ngIf="showTicketProgressBarTimeText && !isTicketProgressBarTimeTextOnRight"
                        [attr.aria-label]="('EXPIRES_IN' | translate) + ': ' + timer.remainingTimeText">
                        {{ timer.remainingTimeText }}
                    </div>

                    <div
                        class="mb-1 flex items-center gap-2"
                        [ngClass]="isTicketProgressBarTimeTextOnRight ? 'mb-0' : ''">
                        <div
                            class="h-1.5 w-full overflow-hidden rounded-full bg-gray-300 dark:border dark:border-solid dark:border-contrast-yellow dark:bg-contrast-black">
                            <div
                                class="h-full rounded-full bg-secondary dark:bg-contrast-yellow"
                                [style.width.%]="timer.progressValue"></div>
                        </div>

                        <div
                            class="text-xs font-semibold text-black dark:text-contrast-yellow"
                            *ngIf="showTicketProgressBarTimeText"
                            [attr.aria-label]="('EXPIRES_IN' | translate) + ': ' + timer.remainingTimeText"
                            [ngClass]="isTicketProgressBarTimeTextOnRight ? 'whitespace-nowrap' : 'hidden'">
                            {{ timer.remainingTimeText }}
                        </div>
                    </div>
                </div>

                <ng-container
                    *ngIf="
                        !isRecent &&
                        ((isTicketDisplayedAsActive && ticket.cardType !== cardType.GLOBAL) ||
                            (isTicketPending && env.TICKET?.SHOW_PENDING_ACTIVATION_DATES))
                    ">
                    <div *ngIf="isTicketDisplayedAsActive; else pendingBlock">
                        <p
                            class="vl-app-light:text-black sr-app-light:text-black text-xs font-medium dark:text-contrast-yellow">
                            <ng-container *ngIf="hasFixedValidityRange(ticket); else dynamicActiveTicketValidity">
                                {{ fixedValidityRangeStart(ticket) | date: 'dd.MM.yyyy HH:mm' }} -
                                {{ fixedValidityRangeEnd(ticket) | date: 'dd.MM.yyyy HH:mm' }}
                            </ng-container>
                            <ng-template #dynamicActiveTicketValidity>
                                <ng-container *ngIf="useUnifiedTicketValidityDisplay; else legacyActiveTicketValidity">
                                    {{
                                        [activeTicketRangeStart(ticket), bookletRangeEnd(ticket)]
                                            | ridangoDateTime: ridangoDateTimeOptions(ticket)
                                    }}
                                </ng-container>
                                <ng-template #legacyActiveTicketValidity>
                                    {{
                                        (env.IS_NEW_AFC ? ticket.startDate : ticket.starting)
                                            | formatTimeZone
                                                : (shouldUseDateTimeForQrTicket(ticket)
                                                      ? primaryDateTimeFormat
                                                      : dateTimeFormat)
                                                : timezone
                                    }}
                                    -
                                    <ng-container *ngIf="isTicketWithQRCode; else adjustedDate">
                                        {{
                                            ticket.ending
                                                | formatTimeZone
                                                    : (shouldUseDateTimeForQrTicket(ticket)
                                                          ? primaryDateTimeFormat
                                                          : dateTimeFormat)
                                                    : timezone
                                                    : null
                                                    : null
                                                    : false
                                                    : ticket
                                        }}
                                    </ng-container>
                                    <ng-template #adjustedDate>
                                        <ng-container
                                            *ngIf="env.IS_NEW_AFC && isTicketPeriodPass; else adjustedDateEndDate">
                                            {{ ticket.endDate | formatTimeZone: dateTimeFormat : timezone }}
                                        </ng-container>
                                        <ng-template #adjustedDateEndDate>
                                            {{
                                                adjustedEndingDate$ | async | formatTimeZone: dateTimeFormat : timezone
                                            }}
                                        </ng-template>
                                    </ng-template>
                                </ng-template>
                            </ng-template>
                        </p>
                    </div>

                    <ng-template #pendingBlock>
                        <p
                            class="vl-app-light:text-black sr-app-light:text-black text-xs font-medium dark:text-contrast-yellow">
                            {{ 'TICKET_WILL_BE_ACTIVATED_ON' | translate }}
                            {{
                                ticket.startDate
                                    | formatTimeZone
                                        : (shouldUseDateTimeForQrTicket(ticket)
                                              ? primaryDateTimeFormat
                                              : dateTimeFormat)
                                        : timezone
                            }}
                        </p>
                    </ng-template>
                </ng-container>
            </div>

            <ion-icon
                class="text-2xl text-[#5E5E5E] dark:text-contrast-yellow"
                *ngIf="isRecent"
                name="chevron-forward-outline"></ion-icon>
        </button>

        <div
            class="orb-app-light:bg-grey-charcoal var-app-light:bg-primary w-0.5 self-stretch opacity-10 dark:bg-contrast-yellow dark:opacity-100"
            *ngIf="env.TICKET?.SHOW_VERTICAL_SEPARATOR_BEFORE_TICKET_ACTIONS"
            style="display: inline-block; vertical-align: middle"></div>

        <ng-container *ngIf="(isOnline$ | async) === true">
            <button
                class="flex flex-col justify-center p-3 md:hidden"
                *ngIf="!isRecent"
                [attr.aria-label]="'MORE_TICKET_ACTIONS' | translate"
                (click)="presentActionSheet()">
                <ion-icon
                    class="var-app-light:text-primary text-2xl text-secondary dark:text-contrast-yellow"
                    name="ellipsis-vertical"
                    aria-hidden="true">
                </ion-icon>
            </button>

            <button
                class="hidden flex-col justify-center p-3 md:flex"
                *ngIf="!isRecent"
                [attr.aria-label]="'MORE_TICKET_ACTIONS' | translate"
                (click)="presentPopover($event)">
                <ion-icon
                    class="var-app-light:text-primary text-2xl text-secondary dark:text-contrast-yellow"
                    name="ellipsis-vertical"
                    aria-hidden="true">
                </ion-icon>
            </button>
        </ng-container>
    </section>

    <div
        class="text-bold bg-grey-zambezy px-4 py-1 text-xs text-white dark:bg-contrast-yellow dark:text-contrast-black"
        *ngIf="ticket.loaned && !isRecent">
        <ng-container *ngIf="ticket.isOwner">
            {{ (env.TICKET_LIST_SHOW_LENT_EMAIL ? 'LENT_TICKET_TO' : 'LENT_TICKET') | translate }}

            <span *ngIf="env.TICKET_LIST_SHOW_LENT_EMAIL">
                {{ ticket.lendingDetails?.lentFareContracts?.[0]?.email }}
            </span>
        </ng-container>

        <ng-container *ngIf="!ticket.isOwner">
            {{ 'BORROWED_TICKET' | translate }}
        </ng-container>
    </div>
</div>

<ng-template #ticketValidityBlock>
    <div class="grid">
        <div class="text-xs">
            <ng-container *ngIf="isTicketRefunded && isHistoryTicket; else ticketValidityActive">
                <span class="vl-app-light:hidden" *ngIf="!env.SHOW_HISTORY_TICKET_REFUND_DATES">
                    {{ 'TICKET_REFUNDED' | translate }}
                </span>

                <span *ngIf="env.SHOW_HISTORY_TICKET_REFUND_DATES">
                    <ng-container *ngTemplateOutlet="refundedOrCanceledDate"></ng-container>
                </span>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #ticketValidityActive>
    <ng-container *ngIf="recentlyUsed; else ticketValidityStillActive">
        <ng-container *ngTemplateOutlet="bookletValidityRange"></ng-container>
    </ng-container>
</ng-template>

<ng-template #ticketValidityStillActive>
    <ng-container
        *ngIf="ticket.validated || isTicketActive || (isHistoryTicket && ticket.starting); else ticketValidityInactive">
        <div *ngIf="ticket.initialUnits === TEN_TRIP_TICKET_UNITS">
            <ng-container *ngTemplateOutlet="tenTripTicket"></ng-container>
        </div>

        <span *ngIf="ticket.initialUnits !== TEN_TRIP_TICKET_UNITS && !isTicketActive">
            <ng-container *ngIf="isPartiallyUsedMultiUnitTicket; else firstValidation">
                <div class="flex flex-col">
                    <span>
                        {{ 'TICKET_SUMMARY_V2_VALIDITY_INFO' | translate }}
                    </span>

                    <span>
                        {{ 'TICKET_SUMMARY_V2_TICKETS_REMAINING' | translate }}:
                        {{ ticket.units }}
                    </span>
                </div>
            </ng-container>
            <ng-template #firstValidation>
                <span *ngIf="isHistoryTicket && !!ticket.bookletEnding">
                    <ng-container *ngTemplateOutlet="bookletValidityRange"></ng-container>
                </span>

                <span *ngIf="!isHistoryTicket">
                    {{ 'ACTIVE_AFTER_FIRST_VALIDATION_NO_LATER_THAN' | translate }}
                    <ng-container *ngTemplateOutlet="ticketExpireDate"></ng-container>
                </span>
            </ng-template>
        </span>
    </ng-container>
</ng-template>

<ng-template #ticketValidityInactive>
    <ng-container
        *ngIf="
            !ticket.activated &&
                (ticket.bookletEnding || ticket.expiredAt || ticket.endDate || hasFixedValidityRange(ticket));
            else ticketValidityAfterValidation
        ">
        <ng-container *ngIf="!env.TICKET_LIST_V2_ENABLED; else ticketValidityExpiredV2">
            <ng-container *ngIf="ticket.initialUnits !== TEN_TRIP_TICKET_UNITS; else inactiveTenTripTicket">
                <div *ngIf="!isTicketCanceled; else ticketValidityCancelled">
                    <ng-container *ngIf="hasFixedValidityRange(ticket); else defaultInactiveExpireDate">
                        <ng-container *ngTemplateOutlet="ticketValidityRange"></ng-container>
                    </ng-container>
                    <ng-template #defaultInactiveExpireDate>
                        <span [class.hidden]="isHistoryTicket && !isTicketCanceled">
                            {{ 'EXPIRES_ON' | translate }}
                        </span>
                        <ng-container *ngTemplateOutlet="ticketExpireDate"></ng-container>
                    </ng-template>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #ticketValidityCancelled>
    <span class="vl-app-light-dark:hidden" *ngIf="!env.SHOW_HISTORY_TICKET_CANCELED_DATES">
        {{ 'CANCELLED_DESCRIPTION' | translate }}
    </span>

    <span *ngIf="env.SHOW_HISTORY_TICKET_CANCELED_DATES">
        <ng-container *ngTemplateOutlet="refundedOrCanceledDate"></ng-container>
    </span>
</ng-template>

<ng-template #ticketValidityExpiredV2>
    <span class="font-medium uppercase text-danger dark:text-contrast-yellow">
        <ng-container [ngSwitch]="ticket.status">
            <ng-container *ngSwitchCase="ticketStatus.Refunded">
                {{ 'RIDE_STATUS_CANCELLED' | translate }}
            </ng-container>

            <ng-container *ngSwitchCase="fareContractStatus.CANCELLED">
                {{ 'RIDE_STATUS_CANCELLED' | translate }}
            </ng-container>

            <ng-container *ngSwitchCase="''">
                {{ 'TICKET_EXPIRED' | translate }}
                {{
                    ticket.endDate
                        | formatTimeZone
                            : (shouldUseDateTimeForQrTicket(ticket) ? primaryDateTimeFormat : dateTimeFormat)
                            : timezone
                }}
            </ng-container>

            <ng-container *ngSwitchCase="ticketStatus.EXPIRED">
                {{ 'TICKET_EXPIRED' | translate }}
                {{
                    ticket.endDate
                        | formatTimeZone
                            : (shouldUseDateTimeForQrTicket(ticket) ? primaryDateTimeFormat : dateTimeFormat)
                            : timezone
                }}
            </ng-container>

            <ng-container *ngSwitchCase="ticketStatus.Returned">
                {{ 'TICKET_REFUNDED' | translate }}
            </ng-container>

            <ng-container *ngSwitchCase="fareContractStatus.REFUNDED">
                {{ 'TICKET_REFUNDED' | translate }}
            </ng-container>
        </ng-container>
    </span>
</ng-template>

<ng-template #ticketValidityAfterValidation>
    <span
        class="font-medium uppercase text-danger dark:text-contrast-yellow"
        *ngIf="
            (ticket.status === fareContractStatus.CANCELLED || ticket.status === fareContractStatus.REFUNDED) &&
                isHistoryTicket;
            else ticketValidityAfterValidationText
        ">
        <ng-container [ngSwitch]="ticket.status">
            <ng-container *ngSwitchCase="fareContractStatus.CANCELLED">
                {{ 'RIDE_STATUS_CANCELLED' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="fareContractStatus.REFUNDED">
                {{ 'TICKET_REFUNDED' | translate }}
            </ng-container>
        </ng-container>
    </span>
</ng-template>

<ng-template #ticketValidityAfterValidationText>
    {{ 'TICKET_SUMMARY_V2_VALIDITY_INFO' | translate }}
</ng-template>

<ng-template #tenTripTicket>
    <div class="flex-column flex">
        <ng-container *ngIf="env?.BOOKLET_TICKETS_WITH_TRIPS_REMAINING_TEXT; else numbersOnly">
            <ng-container *ngIf="ticket.units === TEN_TRIP_TICKET_UNITS && !isTicketDisplayedAsActive">
                <ng-container *ngIf="!isHistoryTicket; else historyTicket">
                    <span>
                        {{ 'ACTIVE_AFTER_FIRST_VALIDATION_NO_LATER_THAN' | translate }}
                        <ng-container *ngTemplateOutlet="ticketExpireDate"></ng-container>
                    </span>
                </ng-container>
                <ng-template #historyTicket>
                    <ng-container *ngTemplateOutlet="bookletValidityRange"></ng-container>
                </ng-template>
            </ng-container>

            <ng-container *ngIf="ticket.units < TEN_TRIP_TICKET_UNITS && !isTicketDisplayedAsActive">
                <ng-container *ngIf="ticket.activated">
                    <span><ng-container *ngTemplateOutlet="ticketValidityRange"></ng-container></span>
                </ng-container>

                <ng-container *ngIf="!ticket.activated">
                    <span *ngIf="!isHistoryTicket">
                        {{ 'TICKET_MUST_BE_USED_BY_END_OFF' | translate }}
                        <ng-container *ngTemplateOutlet="ticketExpireDate"></ng-container>
                    </span>

                    <span *ngIf="isHistoryTicket">
                        <ng-container *ngTemplateOutlet="ticketValidityRange"></ng-container>
                    </span>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="!isHistoryTicket">
                <span>{{ 'NUMBER_OF_TRIPS_REMAINING' | translate }}: {{ ticket.units }}</span>
            </ng-container>
        </ng-container>

        <ng-template #numbersOnly>
            <span>{{ ticket.units }} / {{ ticket.initialUnits }} {{ 'TICKETS_LEFT' | translate }}</span>
        </ng-template>
    </div>
</ng-template>

<ng-template #inactiveTenTripTicket>
    <div class="flex-column flex">
        <ng-container *ngIf="env?.BOOKLET_TICKETS_WITH_TRIPS_REMAINING_TEXT; else remainOnTop">
            <span *ngIf="ticket.units === TEN_TRIP_TICKET_UNITS">
                <ng-container *ngIf="!isHistoryTicket; else historyTicket">
                    {{ 'ACTIVE_AFTER_FIRST_VALIDATION_NO_LATER_THAN' | translate }}
                    <ng-container *ngTemplateOutlet="ticketExpireDate"></ng-container>
                </ng-container>

                <ng-template #historyTicket>
                    <ng-container *ngIf="isTicketCanceled || isTicketRefunded; else otherType">
                        <ng-container *ngTemplateOutlet="cancelRefundDate"></ng-container>
                    </ng-container>

                    <ng-template #otherType>
                        <ng-container *ngIf="!isTicketCanceled">
                            <ng-container *ngTemplateOutlet="ticketExpireDate"></ng-container>
                        </ng-container>
                    </ng-template>
                </ng-template>
            </span>
        </ng-container>

        <ng-template #remainOnTop>
            <span>
                {{ ticket.units }} / {{ ticket.initialUnits }}
                {{ 'TICKETS_LEFT_TO_BE_USED_UNTIL' | translate }}
                <ng-container *ngTemplateOutlet="ticketExpireDate"></ng-container>
            </span>
        </ng-template>
    </div>
</ng-template>

<ng-template #ticketValidityRange>
    <ng-container *ngIf="hasFixedValidityRange(ticket); else dynamicTicketValidityRange">
        {{ fixedValidityRangeStart(ticket) | date: 'dd.MM.yyyy HH:mm' }} -
        {{ fixedValidityRangeEnd(ticket) | date: 'dd.MM.yyyy HH:mm' }}
    </ng-container>
    <ng-template #dynamicTicketValidityRange>
        <ng-container *ngIf="useUnifiedTicketValidityDisplay; else legacyTicketValidityRange">
            {{ [bookletRangeStart(ticket), bookletRangeEnd(ticket)] | ridangoDateTime: ridangoDateTimeOptions(ticket) }}
        </ng-container>
        <ng-template #legacyTicketValidityRange>
            {{
                bookletRangeStart(ticket)
                    | formatTimeZone
                        : (shouldUseDateTimeForQrTicket(ticket) ? primaryDateTimeFormat : env.PERIOD_TICKET_DATE_FORMAT)
                        : timezone
            }}
            —
            {{
                bookletRangeEnd(ticket)
                    | formatTimeZone
                        : (shouldUseDateTimeForQrTicket(ticket) ? primaryDateTimeFormat : env.PERIOD_TICKET_DATE_FORMAT)
                        : timezone
                        : null
                        : null
                        : false
                        : ticket
            }}
        </ng-template>
    </ng-template>
</ng-template>

<ng-template #bookletValidityRange>
    <ng-container *ngIf="hasFixedValidityRange(ticket); else dynamicBookletValidityRange">
        {{ fixedValidityRangeStart(ticket) | date: 'dd.MM.yyyy HH:mm' }} -
        {{ fixedValidityRangeEnd(ticket) | date: 'dd.MM.yyyy HH:mm' }}
    </ng-container>
    <ng-template #dynamicBookletValidityRange>
        <ng-container *ngIf="useUnifiedTicketValidityDisplay; else legacyBookletValidityRange">
            {{ [bookletRangeStart(ticket), bookletRangeEnd(ticket)] | ridangoDateTime: ridangoDateTimeOptions(ticket) }}
        </ng-container>
        <ng-template #legacyBookletValidityRange>
            <ng-container *ngIf="recentlyUsed; else bookletValidityStarting">
                {{ ticket.starting | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : timezone }}
            </ng-container>

            <ng-template #bookletValidityStarting>
                {{ ticket.timestamp || ticket.starting | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : timezone }}
            </ng-template>

            —
            {{
                ticket.ending || ticket.bookletEnding || ticket.expiredAt
                    | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : timezone
            }}
        </ng-template>
    </ng-template>
</ng-template>

<ng-template #ticketExpireDate>
    <ng-container *ngIf="hasFixedValidityRange(ticket); else timezoneExpireDate">
        {{ fixedValidityRangeEnd(ticket) | date: 'dd.MM.yyyy HH:mm' }}
    </ng-container>
    <ng-template #timezoneExpireDate>
        {{ ticket.bookletEnding || ticket.expiredAt | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : timezone }}
    </ng-template>
</ng-template>

<ng-template #cancelRefundDate>
    {{ ticket.timestamp | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : timezone }}
</ng-template>

<ng-template #refundedOrCanceledDate>
    {{ ticket.timestamp | formatTimeZone: env.PERIOD_TICKET_DATE_FORMAT : timezone }}
</ng-template>
